<template>
	<div class="content">
		<div class="profile_info">
			<img
				v-if="!clientDetails.logo"
				src="../assets/client_logo.svg"
				class="profile_image"
				alt=""
			/>
			<img v-else :src="`${clientDetails.logo}`" class="profile_image" alt="" />
		</div>
		<h2><u>PRODUCT LIST</u></h2>
		<div class="wrapper" v-if="productList.length > 0">
			<div
				style="flex-direction: row"
				class="product-card"
				v-for="product in productList"
				:key="product.id"
			>
				<div class="image">
					<b-img
						v-if="product.img_path"
						class="card-img-top"
						alt="Card image cap"
						:src="`${product.img_path}`"
						rounded
					/>
					<img
						v-else
						class="card-img-top"
						alt="Card image cap"
						src="@/assets/static/images/noImage.png"
						rounded
					/>
				</div>
				<div class="card-body">
					<h4 class="card-title card-name">{{ product.name }}</h4>
					<h5 class="product-price">{{ product.price }} €</h5>
					<p>{{ product.description }}</p>
				</div>
				<div class="checkout">
					<router-link
						target="_blank"
						:to="{
						name: 'unitStore',
						params: {
							unitUUID: product.unit_uuid,
							productUUID: product.product_uuid,
						},
						}"
					>
						<div class="trash-btn hideDesktop">
							<span> {{ $t('checkoutP') }}</span>
						</div>
					</router-link>
				</div>
				<div class="qrCode">
					<qrcode-vue
						id="qrcode"
						:value="
						baseUrl +
						'/unitStore/' +
						product.unit_uuid +
						'/product/' +
						product.product_uuid
						"
						:size="size"
						level="H">
					</qrcode-vue>
				</div>
				<hr class="line">
			</div>
		</div>
		<div v-else>No Products available</div>
		<div class="profile_info2 footer">
			<h4>{{ clientDetails.name }}</h4>
			<div>
				<span v-if="clientDetails.address">{{ clientDetails.address }}, </span>
				<span v-if="clientDetails.city">{{ clientDetails.postal_code }} </span>
				<span v-if="clientDetails.postal_code">{{ clientDetails.city }}, </span> 
				<span v-if="clientDetails.country">{{ clientDetails.country }}</span>
			</div>
			<div v-if="clientDetails.vat_no">
				<b>VAT No:</b> {{ clientDetails.vat_no }}
			</div>
			<br/>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import QrcodeVue from 'qrcode.vue'

export default {
	components: {
		QrcodeVue,
	},
	data() {
		return {
		clientDetails: {},
		productList: [],
		//   url: `${process.env.VUE_APP_BASE_URL}/unitStore/${this.product.unit_uuid}/product/${this.product.product_uuid}`,
		url: ``,
		size: 100,
		baseUrl: process.env.VUE_APP_BASE_URL,
		}
	},
	methods: {},
	async mounted() {
		await axios
		.get(
			`${process.env.VUE_APP_API_URL}/client/${this.$route.params.clientId}/productList`
		)
		.then((response) => {
			if (response.data) {
			this.clientDetails = response.data.clientDetails
			this.productList = response.data.productList
			}
		})
	},
}
</script>

<style lang="css" scoped>
h2 {
	font-size: 3rem;
	margin-bottom: 180px;
	font-weight: 800;
	color:var(--bg);
}
.content {
	background-color: var(--bg-superLight);
	/* background: url('../../src/assets/static/images/bg/landing_header_mobile.jpg') no-repeat; */
	background-repeat: repeat-y repeat-x;
	background-position: center;
	background-size: cover;
	height: 100%;
	width: 100%;
}


.footer {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	background-color: var(--bg-light);
	text-align: center;
	color: #f4f4f4;
	z-index: 100;
	padding-top:20px;
}

.profile_info {
	display: flex;
	flex-direction: column;
	justify-content: center;
	/* align-items: start; */
	padding-left: 35px;
	padding-top: 30px;
}
.profile_info .profile_image {
	width: 200px;
	height: 80px;
	/* border-radius: 100px; */
	margin-bottom: 10px;
}
.card-img-top {
	max-height: 200px;
	max-width: 200px;
	object-fit: cover;
	height: 200px;
	width: 100%;
}
.image {
	flex-basis: 40%;
	max-width: 350px;
}
.card-body {
	padding: 0;
	float: left;
	clear: left;
	max-width: 700px;
	height: 100%;
}
.card-body p {
	width: 100%;
	text-align: justify;
	padding: 0 20px 20px 0px;
	color: var(--bright);
}
.card-body h4 {
	text-align: left;
	color: var(--bright);
}
.card-body h5 {
	text-align: left;
	color: var(--bright);
}
.checkout {
	padding: 40px;
}
.checkout a {
	text-decoration: none;
}
/* .card-name {
	color: #454655;
}
.card-text {
	color: #454655;
} */
/* .card {
	flex-direction: row !important;
} */
.product-price {
	font-size: 2em;
}
.card-title {
	font-weight: 600;
	font-size: 1.2rem;
	width: 130px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
  /* position: absolute; */
}

.product-card {
	color: #454655;
	height: 250px;
	padding: 20px;
	margin: 10px;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.product-card:hover {
	background: rgba(128, 128, 128, 0.315);
	color: var(--primary);
	/* margin: 17px; */
	padding: 20px;
	border-radius: 5px;
}
.product-card:active {
	background: #707181;
	/* margin: 16px; */
	padding: 20px;
	border-radius: 5px;
}
.right {
	position: relative;
	float: right;
}
.trash-btn {
    background: var(--primary);
    color: var(--bright) !important;
    padding: 5px;
    letter-spacing: 3px;
    border: none !important;
    border-radius: 7px;
    margin: auto;
    width: 10em;
    height: 32px;
    margin-left: 20px;
}
.wrapper {
	position: relative;
	bottom: 100px;
}

.trash-btn:hover {
text-decoration: none !important;
}

.icon {
	font-size: 1.3em;
	padding: 1px;
}
@media screen and (max-width: 500px) {
	h2 {
		font-size: 2rem !important;
		margin-top: 30px;
		margin-bottom: 0px;
	}
	.product-card {
		width: 100%;
		height: auto !important;
		padding: 30px;
		display: flex;
		flex-direction: column !important;
	}
	.trashIcon {
		width: 40px;
		height: 40px;
		position: relative;
		display: block;
		top: -115px;
		left: -33px;
	}
	.card-body {
		width: 100%;
	}
	.card-title {
		width: 100%;
		font-size: 2rem;
		margin-top: 1.4rem;
	}
	.wrapper {
	display: flex;
	flex-direction: column;
	width: 100% !important;
	top:20px;
	bottom: 150px;
	}
	.checkout {
		padding: 2px;
	}
	.qrCode {
		display: none;
	}
	.line {
		width: 100%;
		color: var(--bright) !important;
	}
	.profile_info {
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 20px;
	}
	.footer {
		font-size: 0.8rem;
	}
}

@media only screen and (min-device-width: 500px) and (orientation: portrait) {
	.product-card {
		margin: 0px;
	}
	.line {
		display: none;
	}
	}

@media only screen and (max-device-width: 900px) and (orientation: landscape) {
	.checkout {
		padding: 5px !important;
	}
	.trash-btn {
	padding: 2px;
	width: 100px;
	}
	.qrCode {
		display: none;
	}
	.card-body {
		max-width: 550px;
		width: 100%;
	}
	.wrapper {
		margin-top: 10px;
	}
}
</style>
